import { gql } from '@apollo/client';
import {
  CommonLocalizableString, CommonLocalizableImage, CommonBoothTier, CommonBoothMetadata,
} from 'network/common/cmsFragment';
import { request } from 'network/queue';

interface FetchMetaBoothByIdProps {
  boothId: string;
  locales: string[];
}

const fetchBoothBasicInfoByIdQuery = gql`
  query fetchBoothBasicInfoByIdQuery(
    $boothId: ID!
    $locales: [Locale!]!
  ) {
    node(id: $boothId) {
      ... on Booth {
        ...CommonBoothMetadata
      }
    }
  }

  ${CommonLocalizableString}
  ${CommonLocalizableImage}
  ${CommonBoothTier}
  ${CommonBoothMetadata}
`;

const fetchBoothMetaById = async (config: FetchMetaBoothByIdProps) => {
  const basicInfo = request({ query: fetchBoothBasicInfoByIdQuery, variables: config });

  const result = {
    ...(await basicInfo).node,
  };

  return result;
};

export default fetchBoothMetaById;
